export default __webpack_public_path__ + "static/media/Resume.afa6d867.pdf";